/* eslint-disable react/no-array-index-key */
import useAutoplay from '@utils/hooks/keenSlider/useAutoplay'
import { useEffect, useState } from 'react'
import { useKeenSlider } from 'keen-slider/react'

type IProps = {
  perspective?: 'right' | 'left' | 'center'
  length: number
  loop?: boolean
  initIdx?: number
  autoplay?: boolean
  label?: string
  setValue?: (i: number, indx?: number) => any | undefined
}

export default function Wheel({
  perspective,
  length,
  loop,
  initIdx,
  autoplay,
  label,
  setValue,
}: IProps) {
  const wheelSize = 20
  const slides = length
  const slideDegree = 360 / wheelSize
  const slidesPerView = loop ? 9 : 1
  // TODO: fix any
  const [sliderState, setSliderState] = useState<any>(null)
  const [sliderRef, slider] = useKeenSlider({
    centered: loop,
    vertical: true,
    friction: 0.0025,
    initial: initIdx || 0,
    loop,
    dragSpeed: ((val: number, instance: any) => {
      const height = instance.details().widthOrHeight
      return (
        val *
        (height /
          ((height / 2) * Math.tan(slideDegree * (Math.PI / 180))) /
          slidesPerView)
      )
    }) as any,
    move: (s) => {
      setSliderState(s.details())
    },
    rubberband: !loop,
    mode: 'free-snap',
    slides,
    slidesPerView,
  })

  if (autoplay) useAutoplay(2000, slider)

  const [radius, setRadius] = useState(0)

  useEffect(() => {
    if (slider) setRadius(slider.details().widthOrHeight / 2)
  }, [slider])

  function slideValues() {
    if (!sliderState) return []
    const offset = loop ? 1 / 2 - 1 / slidesPerView / 2 : 0

    const values = []
    for (let i = 0; i < slides; i += 1) {
      const distance = sliderState
        ? (sliderState.positions[i].distance - offset) * slidesPerView
        : 0
      const rotate =
        Math.abs(distance) > wheelSize / 2
          ? 180
          : distance * (360 / wheelSize) * -1

      const style = {
        transform: `rotateX(${rotate}deg) translateZ(${radius}px)`,
        WebkitTransform: `rotateX(${rotate}deg) translateZ(${radius}px)`,
      }
      const value = setValue
        ? setValue(i, sliderState.absoluteSlide + Math.round(distance))
        : i
      values.push({ style, value })
    }
    return values
  }

  return (
    <div
      className={`wheel keen-slider wheel--perspective-${perspective}`}
      // TODO: fix any
      ref={sliderRef as any}
    >
      <div
        className="wheel__shadow-top"
        style={{
          transform: `translateZ(${radius}px)`,
          WebkitTransform: `translateZ(${radius}px)`,
        }}
      />
      <div className="wheel__inner">
        <div className="wheel__slides">
          {slideValues().map(({ style, value }, idx) => (
            <div className="wheel__slide" style={style} key={idx}>
              <span>{value}</span>
            </div>
          ))}
        </div>
        {label && (
          <div
            className="wheel__label"
            style={{
              transform: `translateZ(${radius}px)`,
              WebkitTransform: `translateZ(${radius}px)`,
            }}
          >
            {label}
          </div>
        )}
      </div>
      <div
        className="wheel__shadow-bottom"
        style={{
          transform: `translateZ(${radius}px)`,
          WebkitTransform: `translateZ(${radius}px)`,
        }}
      />
    </div>
  )
}

Wheel.defaultProps = {
  perspective: 'center',
  loop: false,
  initIdx: 0,
  autoplay: false,
  label: '',
  setValue: undefined,
}
